import { createAction, props } from '@ngrx/store';

export const setMode = createAction('[Global Mode Filter] Set Mode', props<any>());

export const saveCombinedMode = createAction(
	'[Global Mode Filter] Save Combined Mode',
	props<any>()
);
export const setCombinedMode = createAction('[Global Mode Filter] Set Combined Mode', props<any>());
